
angular.module('MEDApp')
.config(['$translateProvider', 'VERSION', function($translateProvider, VERSION) {
    $translateProvider
      .statefulFilter(false)
      .useSanitizeValueStrategy('escape')
      .preferredLanguage('en')
      .useStaticFilesLoader({
          prefix: '/js/dist/translations/combined/',
          suffix: '.json?cb=' + VERSION
      });
}])
.run(['translationService', 'CoreUserService', function(translationService, CoreUserService) {
    CoreUserService.getCurrent(true)
        .then(function(user) {
            translationService.initialize(user.language);
        });
}])
.config(['$provide', function($provide) {

    $provide.constant('SHARABLE_DASHBOARDS_LIMIT', 30);
    $provide.constant('SHARABLE_DASHBOARDS_PREMIUM_LIMIT', 20000);

    $provide.decorator('CoreCompanyService', ['$delegate', '$cookies', 'GYDA_COOKIE_DOMAIN', function($delegate, $cookies, GYDA_COOKIE_DOMAIN) {

        $delegate.createNewCookie = function(cookieData) {
            this.setAuthToken(cookieData.data.token);
            var rememberCookie = $cookies.get('gydaRemember');
            var expireDays = 1;
            if(parseInt(rememberCookie) === 1){
                expireDays = 7;
            }
            var exDate = new Date();
            exDate.setDate(exDate.getDate() + expireDays);
            // Temp removal of old cookie
            $cookies.remove('gydaToken', {domain: 'insight-report.meltwater.com/'});
            $cookies.put('gydaToken', JSON.stringify(cookieData.data), {expires: exDate, domain: GYDA_COOKIE_DOMAIN});
            $cookies.put('gydaRemember', rememberCookie, {expires: exDate, domain: GYDA_COOKIE_DOMAIN});
        };

        return $delegate;
    }]);
}])
.config(['$routeProvider', 'DASHBOARD_SERVICE_DOMAIN_PUBLIC', function($routeProvider, DASHBOARD_SERVICE_DOMAIN_PUBLIC) {
    $routeProvider.when('/facebook_login', {
        template: '',
        activeTab: 'settings',
        title: 'Facebook authentication'
    });
    $routeProvider.when('/facebook_login_success', {
        template: '',
        activeTab: 'settings',
        title: 'Facebook authentication'
    });
}])
.config(['$compileProvider', function($compileProvider) {
    // This should be temporary, see https://toddmotto.com/angular-1-6-is-here#re-enabling-auto-bindings
    $compileProvider.preAssignBindingsEnabled(true);
}])
